import axios from "../../axios";
import { Commit } from 'vuex'

const baseURL = "/exceptions";

export default ({
    namespaced: true,
    state : {
        pumps: [],
        item:{},
        status: 'loading'
    },
    actions : {
        async index({commit}: {commit: Commit}, payload={}){
            commit('SET_STATUS', 'loading')
            const { data } = await axios.get(`${baseURL}`, {params: {...payload}});
            commit('SET_ITEMS', data)
            commit('SET_STATUS', 'completed')
            return data
        },
    },
    mutations:{
        SET_ITEMS(state:any, data: any){
            state.pumps = data.data;
        },
        SET_STATUS(state: any, payload: string){
            state.status = payload;
        },
    },
    getters:{
        items(state: any){
            return state.pumps;
        },
        status(state: any){
            return state.status;
        }
    }
});




